// extracted by mini-css-extract-plugin
module.exports = {"root":"itemList_root__2jnpu","head":"itemList_head__1zyg9","body":"itemList_body__1J61f","divider":"itemList_divider__3gE5v","empty":"itemList_empty__3z9Yz"};